import { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams  } from 'react-router-dom';
import CartContext from '../../store/cart-context';
import ShopContext from '../../store/shop-context';
import { toast } from 'react-toastify';

import { getItem, getSubItems, getPromo } from '../../api/main';
import classes from './styles/ProductView.module.css';

const ProductView = () => {
  const { id, qty, promoId } = useParams();
  const navigate = useNavigate();
  const cartContext = useContext(CartContext);
  // const shopContext = useContext(ShopContext);
  const [qtySelected, setQtySelected] = useState(1);
  // const [promo, setPromo] = useState({});
  const [item, setItem] = useState({});
  const [subproducts, setSubproducts] = useState([]);
  const [selectedSubItems, setSelectedSubItems] = useState([]);
  const [cartTemp, setCartTemp] = useState([]);

  const get = async () => {
    const data = await getItem(id);
    const subproducts = await getSubItems(id);
    setItem({
      ...data,
      // amount: 1,
    });
    setSubproducts(subproducts.map(s => ({ ...s, selected: false })));

    if( promoId ){
      const promoData = await getPromo(id);
      if (promoData.product_id !== parseInt(id))
        navigate("/home");

      // setPromo(promoData);
      setItem(prevState => ({ ...prevState, promo: promoData }));
    }
  }

  useEffect(() => {
    cartContext.setShowFooter(true);
    get();
  }, []);

  const handleAdd = () => {
    if(selectedSubItems.length >= item.min_subproducts && selectedSubItems.length <= item.max_subproducts){

      if(qtySelected < qty)
        setCartTemp(prevState => ([...prevState, { ...item, selectedSubItems }]));
      else {
        let itemToAdd = {
          products: [],
          price: 0,
          discount: 0,
          promo: null
        };

        if( item?.promo ){
          if( item.promo.type_id === 1 ){ // promo 2x1
            cartTemp.map(c => itemToAdd.products.push(c));
            itemToAdd.products.push({ ...item, selectedSubItems });
            itemToAdd.price = itemToAdd.products.reduce((curr, i) => curr + parseInt(i.price), 0);
            itemToAdd.discount = itemToAdd.price * (parseInt(item.promo.discount) / 100);
            itemToAdd.promo = item.promo;
            cartContext.addItem(itemToAdd);
          }
        }else{
          cartTemp.map(c => cartContext.addItem({ ...itemToAdd, products: [c], price: c.price}));
          cartContext.addItem({ ...itemToAdd, products: [{ ...item, selectedSubItems }], price: item.price});
        }
      }

      setSubproducts(subproducts.map(v => ({ ...v, selected: false })));
      setSelectedSubItems([]);
      toast.success("Producto agregado!");

      if(qtySelected < qty){
        setQtySelected(prevState => prevState + 1);
      }else{
        setCartTemp([]);
        navigate("/home");
      }
    }else
      toast.info(`Debes seleccionar hasta ${item.max_subproducts} gustos`);
  }

  const handleSelect = (e) => {
    e.stopPropagation();
    const value = parseInt(e.target.value);
    const subItemToAdd = subproducts.filter(v => v.id === value)[0];

    if(selectedSubItems.filter(v => v.id === value).length > 0){ // remove
      setSelectedSubItems(prevState => prevState.filter(v => v.id !== value));
      setSubproducts(prevState => prevState.map(v => v.id === value ? {...v, selected: false } : v));

    }else{ // add
      if(selectedSubItems.length === item.max_subproducts){
        e.preventDefault();
        return false;
      }

      setSubproducts(prevState => prevState.map(v => v.id === value ? {...v, selected: true } : v));
      setSelectedSubItems(prevState => [...prevState, subItemToAdd]);
    }
  }

  const handleBack = () => {
    setSelectedSubItems([]);
    setCartTemp([]);
    navigate(-1);
  }

  return (
    <section className={classes.productView}>

      <div className={classes.headerImage}>
        <img src={`${window.runtimeConfig.API_URL}/public/shop/${window.runtimeConfig.SHOP_ID}/images/product/${id}`} />
      </div>

      <div className={classes.content}>
        <h3>{item.name} &bull; {item.description}</h3>
        {/* <p className='mb-2'></p> */}

        <ul className={`${classes.subproductList} pe-2 mb-3`}>
          {subproducts && subproducts.map((v, i) => (
            <li key={i} className='form-check'>
              <label className="form-check-label w-100" htmlFor={`subproduct_${i}`}>
                <span className='text-capitalize'>{v.name.toLowerCase()}</span>
                {v.description ? (
                  <>
                    <br /><sub>{v.description}</sub>
                  </>
                ) : <></>}
              </label>
              <input className="form-check-input ms-auto" type="checkbox" value={v.id} checked={v.selected} id={`subproduct_${i}`} onChange={handleSelect} />
            </li>
          ))}
        </ul>

        <div className='d-flex gap-1 flex-column'>
          <button className='btn text-white w-100 my-0 mx-0' onClick={handleAdd}>Agregar al pedido {qty > 1 ? `${qtySelected}/${qty}` : ``}</button>
          <button className='btn text-white w-100 my-0 mx-0 btn-back' onClick={handleBack}>Volver</button>
        </div>
      </div>
    </section>
  );
};

export default ProductView;
